import { QueryClient, useInfiniteQuery } from '@tanstack/react-query';

import { useSearchNonF2fDoctorsForSeoByUserQuery } from '@/hooks/nonBenefit/nonBenefit.gql.impl';
import { parseSearchNonF2fDoctorsForSeoByUser } from '@/parsers/nonBenefit';
import { DiagnosisContactType, NonF2fDoctorSeoSearchRequestInput } from '@/types/bff/gql-schema';

const useSearchNonF2fDoctorsForSeoByUser = (
  request: NonF2fDoctorSeoSearchRequestInput,
  contactType: DiagnosisContactType = DiagnosisContactType.NonF2F,
) => {
  const { data } = useInfiniteQuery(
    useSearchNonF2fDoctorsForSeoByUserQuery.getKey({ request, contactType }),
    ({ pageParam }) => {
      return useSearchNonF2fDoctorsForSeoByUserQuery.fetcher({
        request: {
          ...request,
          page: pageParam || 1,
        },
        contactType: contactType,
      })();
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (
          !lastPage.searchNonF2fDoctorsForSeoByUser.length ||
          lastPage.searchNonF2fDoctorsForSeoByUser.length < request.limit
        ) {
          return undefined;
        }
        return allPages.length + 1;
      },
      staleTime: 1000 * 60 * 5,
      select: parseSearchNonF2fDoctorsForSeoByUser,
    },
  );

  const nonBenefitDoctors = data?.pages.flatMap((doctor) => doctor) || [];

  return { nonBenefitDoctors };
};

export default useSearchNonF2fDoctorsForSeoByUser;

useSearchNonF2fDoctorsForSeoByUser.prefetchQuery = async (
  queryClient: QueryClient,
  request: NonF2fDoctorSeoSearchRequestInput,
  contactType: DiagnosisContactType = DiagnosisContactType.NonF2F,
) => {
  await queryClient.prefetchInfiniteQuery(
    useSearchNonF2fDoctorsForSeoByUserQuery.getKey({ request, contactType }),
    useSearchNonF2fDoctorsForSeoByUserQuery.fetcher({ request, contactType }),
  );
};
